// extracted by mini-css-extract-plugin
module.exports = {"className":"te-IN_className__TURr9"};